document.addEventListener('DOMContentLoaded', async () => {
    if (document.querySelector('.termine')) {
        const url = '/blog/termine'
        const state = {
            page: 0,
            maxPage: 1
        };

        const teaserElement = document.querySelector('.termine-list');
        const textSearch = document.querySelector('.filter-text');
        const textSearchInput = textSearch.querySelector('input');
        const buttonPrev = document.querySelector('.previous');
        const buttonNext = document.querySelector('.next');
        const buttonNow = document.querySelector('.now');

        const update = function (html) {
            teaserElement.innerHTML = html;
            if (state.page === 0) {
                buttonNext.setAttribute('disabled', '');
            } else {
                buttonNext.removeAttribute('disabled')
            }

            if (state.page < state.maxPage) {
                buttonPrev.removeAttribute('disabled')
            } else {
                buttonPrev.setAttribute('disabled', '')
            }
        }

        const loadEvents = async function (options = {}) {
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(options)
            });
            const teasers = await response.json();
            state.maxPage = teasers.numberOfPages;
            return teasers.html;
        }

        const init = async function () {
            update(await loadEvents());
        }
        await init();

        buttonPrev.addEventListener('click', async () => {
            state.page++
            update(await loadEvents(state))
        });

        buttonNext.addEventListener('click', async () => {
            state.page--;
            update(await loadEvents(state));
        });

        buttonNow.addEventListener('click', async () => {
            state.page = 0;
            update(await loadEvents(state));
        });

        textSearch.addEventListener('submit', (event) => {
            event.preventDefault();
            textSearchInput.blur();
        })
        textSearchInput.addEventListener('blur', async () => {
            state.page = 0;
            state.text = textSearchInput.value;
            update(await loadEvents(state));
        })
    }
})